<template>
    <el-row :gutter="30"  class="mw-100 manage-user" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-form
                    :model="currentUserData"
                    :rules="currentUserDataRules"
                    ref="currentUserRef"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageUser('currentUserRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="firs tName" prop="firstName">
                                <el-input type="text" v-model="currentUserData.firstName"></el-input>    
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="last Name" prop="lastName">
                                <el-input type="text" v-model="currentUserData.lastName"></el-input>    
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="company Name" prop="companyName">
                                <el-input type="text" v-model="currentUserData.companyName"></el-input>    
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="email" prop="email">
                                <el-input type="text" v-model="currentUserData.email"></el-input>    
                            </el-form-item>
                        </el-col>
                       
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="phone" prop="phone">
                                <el-input type="text" v-model="currentUserData.phone"></el-input>    
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddUser:true,
            currentUser:[],
           
            currentUserData:{},
            currentUserDataRules:{
                companyName:[
                    {
                        required:true,
                        message:'required field',
                        trigger:'blur',
                    }
                ],
                email:[
                    {
                        required:true,
                        message:'required field',
                        trigger:'blur',
                    }
                ],
                firstName:[
                    {
                        required:true,
                        message:'required field',
                        trigger:'blur',
                    }
                ],
                lastName:[
                    {
                        required:true,
                        message:'required field',
                        trigger:'blur',
                    }
                ],
                phone:[
                    {
                        required:true,
                        message:'required field',
                        trigger:'blur',
                    }
                ],
            }
        };
    },
    computed:{
        cachedUser(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website.user.currentUser || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedUser.id) {
            this.isAddUser = false;
            this.currentUserData = JSON.parse(JSON.stringify(this.cachedUser))
        }else{
            this.$router.push({
                name:'manage-user',
            })
            this.isAddUser = true;
            this.currentUserData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                companyName: "",
                email: "",
                firstName: "",
                lastName: "",
                phone: ""
            }
        },
       
        async manageUser(formName){
            const element = this.$refs[formName];
            element.validate(async (valid) => {
                if (!valid) {
                    return
                }
            }).then(data =>{
                if (data){
                    this.manageUserAfterValidate()
                }
            })  
           
            
            
            
            
            
        },
        async manageUserAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddUser ? 'addUser':'editUser',this.currentUserData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllUsers',0);
                this.$router.push({
                    name:'users-list'
                })
            }
        }   
    }
}
</script>
<style lang="scss">
    .manage-user {
        .ck-editor {
            width:100%;
        }
    }
</style>